import { Checkbox, Divider, FormControl, FormControlLabel, Grid, InputLabel, MenuItem, Paper, Select, Typography, Button } from '@material-ui/core';
import React, { useGlobal } from 'reactn';
import { NumberField } from '../../components/NumberField';
import { SectionSubTitle } from '../../components/SectionSubTitle';
import { IGlobalState } from '../../states/GlobalState';
import { globalStyles } from '../../style/GlobalStyles';
import { API_elaboraSchedaBudget } from '../../utils/functions';
import { SchedaBudgetInputProps } from './InformazioniCosti';
import ComputeIcon from '@material-ui/icons/Cached';

export default function SocietaDiPersoneSrlRegTrasparenza(props: SchedaBudgetInputProps) {
    const gClasses = globalStyles();
    const action = "changeImposteContributi";
    const { state } = props;
    const [global] = useGlobal<IGlobalState>();

    const handleChange = (e: any) => {
        let { name, value } = e.target;
        props.handleChange(action, name, value);
    }
    const handleBlur = (e: any) => {
        API_elaboraSchedaBudget(props, global);
    }
    const handleChangeSelect = (e: any) => {
        handleChange(e);
        let { name, value } = e.target;
        API_elaboraSchedaBudget(props, global, name, value, action, true);
    }

    const calcolaQuote = (e: any) => {
        props.handleChange(action, "RicalcolaQuoteSoci", true);
        API_elaboraSchedaBudget(props, global, "RicalcolaQuoteSoci", true, action, true);
    }

    const handleChangeChecked = (e: any) => {
        let { name, checked } = e.target;

        if (name === "F154_artigiano" && checked === true && state.imposteContributi.F155_commerciante === true)
            state.imposteContributi.F155_commerciante = false;
        else if (name === "F155_commerciante" && checked === true && state.imposteContributi.F154_artigiano === true)
            state.imposteContributi.F154_artigiano = false

        props.handleChange(action, name, checked);
        API_elaboraSchedaBudget(props, global, name, checked, action, true);
    };

    return (
        <Paper className={gClasses.fullWidthPaper}>
            <Grid container>
                <SectionSubTitle text="Tipologia"></SectionSubTitle>
                <Grid container>
                    <FormControlLabel className={gClasses.bottomControlLabel}
                        labelPlacement="end"
                        control={
                            <Checkbox
                                checked={state.imposteContributi.F154_artigiano}
                                name='F154_artigiano'
                                id='F154_artigiano'
                                value={state.imposteContributi.F154_artigiano}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                onChange={handleChangeChecked}
                            />
                        }
                        label="Artigiano"
                    />
                    <FormControlLabel className={gClasses.bottomControlLabel}
                        labelPlacement="end"
                        control={
                            <Checkbox
                                checked={state.imposteContributi.F155_commerciante}
                                name='F155_commerciante'
                                id='F155_commerciante'
                                value={state.imposteContributi.F155_commerciante}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                onChange={handleChangeChecked}
                            />
                        }
                        label="Commerciante"
                    />

                    <Grid>
                        <FormControl className={gClasses.formControl}>
                            <InputLabel htmlFor="F157_nsoci">Numero soci</InputLabel>
                            <Select
                                className={gClasses.select}
                                value={state.imposteContributi.F157_nsoci}
                                onChange={handleChangeSelect}
                                inputProps={{ name: 'F157_nsoci', id: 'F157_nsoci' }}
                            >
                                <MenuItem value={0}>Non definito</MenuItem>
                                <MenuItem value={1}>1</MenuItem>
                                <MenuItem value={2}>2</MenuItem>
                                <MenuItem value={3}>3</MenuItem>
                                <MenuItem value={4}>4</MenuItem>
                                <MenuItem value={5}>5</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
                <Divider></Divider>
                <Grid container direction="column" justify="flex-start" alignItems="flex-start">
                    <SectionSubTitle text="Quote"></SectionSubTitle>
                    <Button onClick={calcolaQuote}>
                        <Typography variant="button">Calcola quote</Typography>
                        <ComputeIcon style={{ color: "#009688", marginLeft: "5px", marginBottom: "5px", height: "17px" }}></ComputeIcon>
                    </Button>
                </Grid>
                <Grid container direction="row">
                    <NumberField
                        name="F161_quota_socio"
                        label="Quota % socio"
                        value={state.imposteContributi.F161_quota_socio}
                        className={gClasses.textField}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        symbol="%"
                    />
                    <FormControlLabel className={gClasses.bottomControlLabel}
                        labelPlacement="end"
                        control={
                            <Checkbox
                                checked={state.imposteContributi.C161_no_contributi}
                                name='C161_no_contributi'
                                id='C161_no_contributi'
                                value={state.imposteContributi.C161_no_contributi}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                onChange={handleChangeChecked}
                            />
                        }
                        label="No contributi"
                    />
                </Grid>
                <Grid container direction="row">
                    <NumberField
                        name="F162_quota_socio"
                        label="Quota % socio"
                        value={state.imposteContributi.F162_quota_socio}
                        className={gClasses.textField}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        symbol="%"
                    />
                    <FormControlLabel className={gClasses.bottomControlLabel}
                        labelPlacement="end"
                        control={
                            <Checkbox
                                checked={state.imposteContributi.C162_no_contributi}
                                name='C162_no_contributi'
                                id='C162_no_contributi'
                                value={state.imposteContributi.C162_no_contributi}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                onChange={handleChangeChecked}
                            />
                        }
                        label="No contributi"
                    />

                </Grid>
                <Grid container direction="row">
                    <NumberField
                        name="F163_quota_socio"
                        label="Quota % socio"
                        value={state.imposteContributi.F163_quota_socio}
                        className={gClasses.textField}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        symbol="%"
                    />
                    <FormControlLabel className={gClasses.bottomControlLabel}
                        labelPlacement="end"
                        control={
                            <Checkbox
                                checked={state.imposteContributi.C163_no_contributi}
                                name='C163_no_contributi'
                                id='C163_no_contributi'
                                value={state.imposteContributi.C163_no_contributi}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                onChange={handleChangeChecked}
                            />
                        }
                        label="No contributi"
                    />

                </Grid>
                <Grid container direction="row">
                    <NumberField
                        name="F164_quota_socio"
                        label="Quota % socio"
                        value={state.imposteContributi.F164_quota_socio}
                        className={gClasses.textField}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        symbol="%"
                    />
                    <FormControlLabel className={gClasses.bottomControlLabel}
                        labelPlacement="end"
                        control={
                            <Checkbox
                                checked={state.imposteContributi.C164_no_contributi}
                                name='C164_no_contributi'
                                id='C164_no_contributi'
                                value={state.imposteContributi.C164_no_contributi}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                onChange={handleChangeChecked}
                            />
                        }
                        label="No contributi"
                    />

                </Grid>
                <Grid container direction="row">
                    <NumberField
                        name="F165_quota_socio"
                        label="Quota % socio"
                        value={state.imposteContributi.F165_quota_socio}
                        className={gClasses.textField}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        symbol="%"
                    />
                    <FormControlLabel className={gClasses.bottomControlLabel}
                        labelPlacement="end"
                        control={
                            <Checkbox
                                checked={state.imposteContributi.C165_no_contributi}
                                name='C165_no_contributi'
                                id='C165_no_contributi'
                                value={state.imposteContributi.C165_no_contributi}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                onChange={handleChangeChecked}
                            />
                        }
                        label="No contributi"
                    />

                </Grid>
                <Grid container direction="row">
                    <NumberField
                        name="F166_totale"
                        label="Totale"
                        value={state.imposteContributi.F166_totale}
                        className={gClasses.textFieldReadOnly}
                        readOnly={true}
                        symbol="%"
                        forcedError={state.imposteContributi.F166_totale !== 100}
                        forcedErrorMessage="La quota totale è diversa da 100%"
                    />
                </Grid>
                <Grid>
                    <Divider></Divider>
                    <SectionSubTitle text="Carichi familiari"></SectionSubTitle>
                    <Typography variant="subtitle2">{state.informazioniCostiDiAvvio.tipologia === "SOCIETA_DI_PERSONE"
                        || state.informazioniCostiDiAvvio.tipologia === "SRL_TRASPARENTE" ? "Socio 1" : "Collaboratore 1"}</Typography>
                    <FormControlLabel className={gClasses.bottomControlLabel}
                        labelPlacement="end"
                        control={
                            <Checkbox
                                checked={state.imposteContributi.H161_coniuge}
                                name='H161_coniuge'
                                id='H161_coniuge'
                                value={state.imposteContributi.H161_coniuge}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                onChange={handleChangeChecked}
                            />
                        }
                        label="Coniuge"
                    />
                    <FormControl className={gClasses.formControl}>
                        <InputLabel htmlFor="nfigli">N. Figli</InputLabel>
                        <Select
                            autoWidth={true}
                            className={gClasses.select}
                            value={state.imposteContributi.I161_nfigli}
                            onChange={handleChangeSelect}
                            inputProps={{ name: 'I161_nfigli', id: 'I161_nfigli' }}
                        >
                            <MenuItem value={0}>Non definito</MenuItem>
                            <MenuItem value={1}>1</MenuItem>
                            <MenuItem value={2}>2</MenuItem>
                            <MenuItem value={3}>3</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl className={gClasses.formControl}>
                        <InputLabel htmlFor="pfigli">% Figli</InputLabel>
                        <Select
                            className={gClasses.select}
                            value={state.imposteContributi.J161_pfigli}
                            onChange={handleChangeSelect}
                            inputProps={{ name: 'J161_pfigli', id: 'J161_pfigli' }}
                        >
                            <MenuItem value={0}>Non definito</MenuItem>
                            <MenuItem value={50}>50%</MenuItem>
                            <MenuItem value={100}>100%</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid>
                    <Typography variant="subtitle2">{state.informazioniCostiDiAvvio.tipologia === "SOCIETA_DI_PERSONE"
                        || state.informazioniCostiDiAvvio.tipologia === "SRL_TRASPARENTE" ? "Socio 2" : "Collaboratore 2"}</Typography>
                    <FormControlLabel className={gClasses.bottomControlLabel}
                        labelPlacement="end"
                        control={
                            <Checkbox
                                checked={state.imposteContributi.H162_coniuge}
                                name='H162_coniuge'
                                id='H162_coniuge'
                                value={state.imposteContributi.H162_coniuge}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                onChange={handleChangeChecked}
                            />
                        }
                        label="Coniuge"
                    />
                    <FormControl className={gClasses.formControl}>
                        <InputLabel htmlFor="nfigli_1">N. Figli</InputLabel>
                        <Select
                            autoWidth={true}
                            className={gClasses.select}
                            value={state.imposteContributi.I162_nfigli}
                            onChange={handleChangeSelect}
                            inputProps={{ name: 'I162_nfigli', id: 'I162_nfigli' }}
                        >
                            <MenuItem value={0}>Non definito</MenuItem>
                            <MenuItem value={1}>1</MenuItem>
                            <MenuItem value={2}>2</MenuItem>
                            <MenuItem value={3}>3</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl className={gClasses.formControl}>
                        <InputLabel htmlFor="pfigli_1">% Figli</InputLabel>
                        <Select
                            className={gClasses.select}
                            value={state.imposteContributi.J162_pfigli}
                            onChange={handleChangeSelect}
                            inputProps={{ name: 'J162_pfigli', id: 'J162_pfigli' }}
                        >
                            <MenuItem value={0}>Non definito</MenuItem>
                            <MenuItem value={50}>50%</MenuItem>
                            <MenuItem value={100}>100%</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid>
                    <Typography variant="subtitle2">{state.informazioniCostiDiAvvio.tipologia === "SOCIETA_DI_PERSONE"
                        || state.informazioniCostiDiAvvio.tipologia === "SRL_TRASPARENTE" ? "Socio 3" : "Collaboratore 3"}</Typography>
                    <FormControlLabel className={gClasses.bottomControlLabel} 
                        labelPlacement="end"
                        control={
                            <Checkbox
                                checked={state.imposteContributi.H163_coniuge}
                                name='H163_coniuge'
                                id='H163_coniuge'
                                value={state.imposteContributi.H163_coniuge}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                onChange={handleChangeChecked}
                            />
                        }
                        label="Coniuge"
                    />
                    <FormControl className={gClasses.formControl}>
                        <InputLabel htmlFor="nfigli_2">N. Figli</InputLabel>
                        <Select
                            autoWidth={true}
                            className={gClasses.select}
                            value={state.imposteContributi.I163_nfigli}
                            onChange={handleChangeSelect}
                            inputProps={{ name: 'I163_nfigli', id: 'I163_nfigli' }}
                        >
                            <MenuItem value={0}>Non definito</MenuItem>
                            <MenuItem value={1}>1</MenuItem>
                            <MenuItem value={2}>2</MenuItem>
                            <MenuItem value={3}>3</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl className={gClasses.formControl}>
                        <InputLabel htmlFor="pfigli_2">% Figli</InputLabel>
                        <Select
                            className={gClasses.select}
                            value={state.imposteContributi.J163_pfigli}
                            onChange={handleChangeSelect}
                            inputProps={{ name: 'J163_pfigli', id: 'J163_pfigli' }}
                        >
                            <MenuItem value={0}>Non definito</MenuItem>
                            <MenuItem value={50}>50%</MenuItem>
                            <MenuItem value={100}>100%</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid>
                    <Typography variant="subtitle2">{state.informazioniCostiDiAvvio.tipologia === "SOCIETA_DI_PERSONE"
                        || state.informazioniCostiDiAvvio.tipologia === "SRL_TRASPARENTE" ? "Socio 4" : "Collaboratore 4"}</Typography>
                    <FormControlLabel className={gClasses.bottomControlLabel}
                        labelPlacement="end"
                        control={
                            <Checkbox
                                checked={state.imposteContributi.H164_coniuge}
                                name='H164_coniuge'
                                id='H164_coniuge'
                                value={state.imposteContributi.H164_coniuge}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                onChange={handleChangeChecked}
                            />
                        }
                        label="Coniuge"
                    />
                    <FormControl className={gClasses.formControl}>
                        <InputLabel htmlFor="nfigli_3">N. Figli</InputLabel>
                        <Select
                            autoWidth={true}
                            className={gClasses.select}
                            value={state.imposteContributi.I164_nfigli}
                            onChange={handleChangeSelect}
                            inputProps={{ name: 'I164_nfigli', id: 'I164_nfigli' }}
                        >
                            <MenuItem value={0}>Non definito</MenuItem>
                            <MenuItem value={1}>1</MenuItem>
                            <MenuItem value={2}>2</MenuItem>
                            <MenuItem value={3}>3</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl className={gClasses.formControl}>
                        <InputLabel htmlFor="pfigli_3">% Figli</InputLabel>
                        <Select
                            className={gClasses.select}
                            value={state.imposteContributi.J164_pfigli}
                            onChange={handleChangeSelect}
                            inputProps={{ name: 'J164_pfigli', id: 'J164_pfigli' }}
                        >
                            <MenuItem value={0}>Non definito</MenuItem>
                            <MenuItem value={50}>50%</MenuItem>
                            <MenuItem value={100}>100%</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
                <Grid>
                    <Typography variant="subtitle2">{state.informazioniCostiDiAvvio.tipologia === "SOCIETA_DI_PERSONE"
                        || state.informazioniCostiDiAvvio.tipologia === "SRL_TRASPARENTE" ? "Socio 5" : "Collaboratore 5"}</Typography>
                    <FormControlLabel className={gClasses.bottomControlLabel}
                        labelPlacement="end"
                        control={
                            <Checkbox
                                checked={state.imposteContributi.H165_coniuge}
                                name='H165_coniuge'
                                id='H165_coniuge'
                                value={state.imposteContributi.H165_coniuge}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                                onChange={handleChangeChecked}
                            />
                        }
                        label="Coniuge"
                    />
                    <FormControl className={gClasses.formControl}>
                        <InputLabel htmlFor="nfigli_4">N. Figli</InputLabel>
                        <Select
                            autoWidth={true}
                            className={gClasses.select}
                            value={state.imposteContributi.I165_nfigli}
                            onChange={handleChangeSelect}
                            inputProps={{ name: 'I165_nfigli', id: 'I165_nfigli' }}
                        >
                            <MenuItem value={0}>Non definito</MenuItem>
                            <MenuItem value={1}>1</MenuItem>
                            <MenuItem value={2}>2</MenuItem>
                            <MenuItem value={3}>3</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl className={gClasses.formControl}>
                        <InputLabel htmlFor="pfigli_4">% Figli</InputLabel>
                        <Select
                            className={gClasses.select}
                            value={state.imposteContributi.J165_pfigli}
                            onChange={handleChangeSelect}
                            inputProps={{ name: 'J165_pfigli', id: 'J165_pfigli' }}
                        >
                            <MenuItem value={0}>Non definito</MenuItem>
                            <MenuItem value={50}>50%</MenuItem>
                            <MenuItem value={100}>100%</MenuItem>
                        </Select>
                    </FormControl>
                </Grid>
            </Grid>
        </Paper>
    )
}